/**
 * 조선제학교 일람 데이터
 */
export const IlamListData =
    [
        {
            "book_id" : 39,
            "book_type" : null,
            "book_category" : "joseon_school_catalog",
            "book_title" : "朝鮮諸學校一覽 大正6年5月末",
            "book_title_ko" : "조선제학교일람 1917년도",
            "numeration" : "1917",
            "authors" : null,
            "authors_ko" : null,
            "publish_info" : null,
            "publish_year" : 1918,
            "publish_month" : 1,
            "publish_day" : 4,
            "publish_date" : "대정7년1월4일",
            "publisher" : "朝鮮總督府>內務部>學務局",
            "publisher_ko" : "조선총독부>내무부>학무국",
            "library" : null,
            "url" : null,
            "note" : "本表ハ大正6年5月末ノ現在ニ依リ調製セリ ; 表中職員欄「X」印ヲ附シタルハ兼務者「△」印印ヲ附シタルハ外國人ヲ示シ共ニ外書トス ; 經費ハ大正6年度豫算ヲ揭上ス",
            "search_tag" : null,
            "usernote" : null
        },
        {
            "book_id" : 40,
            "book_type" : null,
            "book_category" : "joseon_school_catalog",
            "book_title" : "朝鮮諸學校一覽 大正7年5月末",
            "book_title_ko" : "조선제학교일람 1918년도",
            "numeration" : "1918",
            "authors" : null,
            "authors_ko" : null,
            "publish_info" : null,
            "publish_year" : 1919,
            "publish_month" : 1,
            "publish_day" : 4,
            "publish_date" : "대정8년1월4일",
            "publisher" : "朝鮮總督府>學務局",
            "publisher_ko" : "조선총독부>학무국",
            "library" : null,
            "url" : null,
            "note" : "本表ハ大正7年5月末ノ現在ニ依リ調製セリ ; 表中職員欄X印ハ兼務者△印ハ外國人ヲ示シ共ニ外書トス ; 經費ハ大正7年度豫算ヲ揭上ス",
            "search_tag" : null,
            "usernote" : null
        },
        {
            "book_id" : 41,
            "book_type" : null,
            "book_category" : "joseon_school_catalog",
            "book_title" : "朝鮮諸學校一覽 大正8年5月末",
            "book_title_ko" : "조선제학교일람 1919년도",
            "numeration" : "1919",
            "authors" : null,
            "authors_ko" : null,
            "publish_info" : null,
            "publish_year" : null,
            "publish_month" : null,
            "publish_day" : null,
            "publish_date" : null,
            "publisher" : "朝鮮總督府>學務局",
            "publisher_ko" : "조선총독부>학무국",
            "library" : null,
            "url" : null,
            "note" : "本表ハ大正8年5月末ノ現在ニ依リ調製セリ ; 表中職員欄X印ハ兼務者△印ハ外國人ヲ示シ共ニ外書トス ; 經費ハ大正8年度豫算ヲ揭上ス",
            "search_tag" : null,
            "usernote" : null
        },
        {
            "book_id" : 42,
            "book_type" : null,
            "book_category" : "joseon_school_catalog",
            "book_title" : "朝鮮諸學校一覽 大正10年5月末",
            "book_title_ko" : "조선제학교일람 1921년도",
            "numeration" : "1921",
            "authors" : null,
            "authors_ko" : null,
            "publish_info" : null,
            "publish_year" : 1921,
            "publish_month" : 10,
            "publish_day" : 5,
            "publish_date" : "대정10년10월5일",
            "publisher" : "朝鮮總督府>學務局",
            "publisher_ko" : "조선총독부>학무국",
            "library" : null,
            "url" : null,
            "note" : "1. 本表中職員欄X印ハ兼務者△印ハ外國人ヲ示シ共ニ外書トス ; 1. 經費ハ大正10年度豫算ヲ揭上ス",
            "search_tag" : null,
            "usernote" : null
        },
        {
            "book_id" : 43,
            "book_type" : null,
            "book_category" : "joseon_school_catalog",
            "book_title" : "朝鮮諸學校一覽 大正11年5月末",
            "book_title_ko" : "조선제학교일람 1922년도",
            "numeration" : "1922",
            "authors" : null,
            "authors_ko" : null,
            "publish_info" : null,
            "publish_year" : 1923,
            "publish_month" : 3,
            "publish_day" : 31,
            "publish_date" : "대정12년3월31일",
            "publisher" : "朝鮮總督府>學務局",
            "publisher_ko" : "조선총독부>학무국",
            "library" : null,
            "url" : null,
            "note" : "1. 本表ハ大正11年5月末ノ現在ニ依リ調製セリ ; 1. 表中職員欄X印ハ兼務者△印ハ外國人ヲ示シ共ニ外書トス ; 1. 經費ハ大正11年度豫算ヲ揭上ス",
            "search_tag" : null,
            "usernote" : null
        },
        {
            "book_id" : 44,
            "book_type" : null,
            "book_category" : "joseon_school_catalog",
            "book_title" : "朝鮮諸學校一覽 大正12年5月末",
            "book_title_ko" : "조선제학교일람 1923년도",
            "numeration" : "1923",
            "authors" : null,
            "authors_ko" : null,
            "publish_info" : null,
            "publish_year" : 1924,
            "publish_month" : null,
            "publish_day" : null,
            "publish_date" : "대정13년",
            "publisher" : "朝鮮總督府>學務局",
            "publisher_ko" : "조선총독부>학무국",
            "library" : null,
            "url" : null,
            "note" : "經費ハ大正十二年度豫算ヲ揭上ス",
            "search_tag" : null,
            "usernote" : null
        },
        {
            "book_id" : 45,
            "book_type" : null,
            "book_category" : "joseon_school_catalog",
            "book_title" : "朝鮮諸學校一覽 大正13年5月末",
            "book_title_ko" : "조선제학교일람 1924년도",
            "numeration" : "1924",
            "authors" : null,
            "authors_ko" : null,
            "publish_info" : null,
            "publish_year" : 1924,
            "publish_month" : 12,
            "publish_day" : 10,
            "publish_date" : "대정13년12월10일",
            "publisher" : "朝鮮總督府>學務局",
            "publisher_ko" : "조선총독부>학무국",
            "library" : null,
            "url" : null,
            "note" : "經費ハ大正十三年度豫算ヲ揭上ス",
            "search_tag" : null,
            "usernote" : null
        },
        {
            "book_id" : 46,
            "book_type" : null,
            "book_category" : "joseon_school_catalog",
            "book_title" : "朝鮮諸學校一覽 大正14年5月末",
            "book_title_ko" : "조선제학교일람 1925년도",
            "numeration" : "1925",
            "authors" : null,
            "authors_ko" : null,
            "publish_info" : null,
            "publish_year" : 1926,
            "publish_month" : 9,
            "publish_day" : 30,
            "publish_date" : "대정15년9월30일",
            "publisher" : "朝鮮總督府>學務局",
            "publisher_ko" : "조선총독부>학무국",
            "library" : null,
            "url" : null,
            "note" : "1. 經費ハ大正十四年度豫算ヲ揭上ス",
            "search_tag" : null,
            "usernote" : null
        },
        {
            "book_id" : 47,
            "book_type" : null,
            "book_category" : "joseon_school_catalog",
            "book_title" : "朝鮮諸學校一覽 大正15年5月末",
            "book_title_ko" : "조선제학교일람 1926년도",
            "numeration" : "1926",
            "authors" : null,
            "authors_ko" : null,
            "publish_info" : null,
            "publish_year" : 1927,
            "publish_month" : 1,
            "publish_day" : 31,
            "publish_date" : "소화2년1월31일",
            "publisher" : "朝鮮總督府>學務局",
            "publisher_ko" : "조선총독부>학무국",
            "library" : null,
            "url" : null,
            "note" : null,
            "search_tag" : null,
            "usernote" : null
        },
        {
            "book_id" : 48,
            "book_type" : null,
            "book_category" : "joseon_school_catalog",
            "book_title" : "朝鮮諸學校一覽 昭和2年5月末",
            "book_title_ko" : "조선제학교일람 1927년도",
            "numeration" : "1927",
            "authors" : null,
            "authors_ko" : null,
            "publish_info" : null,
            "publish_year" : 1928,
            "publish_month" : 3,
            "publish_day" : 31,
            "publish_date" : "소화3년3월31일",
            "publisher" : "朝鮮總督府>學務局",
            "publisher_ko" : "조선총독부>학무국",
            "library" : null,
            "url" : null,
            "note" : null,
            "search_tag" : null,
            "usernote" : null
        },
        {
            "book_id" : 49,
            "book_type" : null,
            "book_category" : "joseon_school_catalog",
            "book_title" : "朝鮮諸學校一覽 昭和3年5月末",
            "book_title_ko" : "조선제학교일람 1928년도",
            "numeration" : "1928",
            "authors" : null,
            "authors_ko" : null,
            "publish_info" : null,
            "publish_year" : 1928,
            "publish_month" : 12,
            "publish_day" : 13,
            "publish_date" : "소화3년12월13일",
            "publisher" : "朝鮮總督府>學務局",
            "publisher_ko" : "조선총독부>학무국",
            "library" : null,
            "url" : null,
            "note" : null,
            "search_tag" : null,
            "usernote" : null
        },
        {
            "book_id" : 50,
            "book_type" : null,
            "book_category" : "joseon_school_catalog",
            "book_title" : "朝鮮諸學校一覽 昭和4年5月末",
            "book_title_ko" : "조선제학교일람 1929년도",
            "numeration" : "1929",
            "authors" : null,
            "authors_ko" : null,
            "publish_info" : null,
            "publish_year" : 1930,
            "publish_month" : 1,
            "publish_day" : 20,
            "publish_date" : "소화5년1월20일",
            "publisher" : "朝鮮總督府>學務局",
            "publisher_ko" : "조선총독부>학무국",
            "library" : null,
            "url" : null,
            "note" : null,
            "search_tag" : null,
            "usernote" : null
        },
        {
            "book_id" : 51,
            "book_type" : null,
            "book_category" : "joseon_school_catalog",
            "book_title" : "朝鮮諸學校一覽 昭和5年5月末",
            "book_title_ko" : "조선제학교일람 1930년도",
            "numeration" : "1930",
            "authors" : null,
            "authors_ko" : null,
            "publish_info" : null,
            "publish_year" : 1931,
            "publish_month" : 6,
            "publish_day" : 5,
            "publish_date" : "소화6년6월5일",
            "publisher" : "朝鮮總督府>學務局",
            "publisher_ko" : "조선총독부>학무국",
            "library" : null,
            "url" : null,
            "note" : null,
            "search_tag" : null,
            "usernote" : null
        },
        {
            "book_id" : 52,
            "book_type" : null,
            "book_category" : "joseon_school_catalog",
            "book_title" : "朝鮮諸學校一覽 昭和6年5月末",
            "book_title_ko" : "조선제학교일람 1931년도",
            "numeration" : "1931",
            "authors" : null,
            "authors_ko" : null,
            "publish_info" : null,
            "publish_year" : 1932,
            "publish_month" : 6,
            "publish_day" : 5,
            "publish_date" : "소화7년6월5일",
            "publisher" : "朝鮮總督府>學務局",
            "publisher_ko" : "조선총독부>학무국",
            "library" : null,
            "url" : null,
            "note" : null,
            "search_tag" : null,
            "usernote" : null
        },
        {
            "book_id" : 53,
            "book_type" : null,
            "book_category" : "joseon_school_catalog",
            "book_title" : "朝鮮諸學校一覽 昭和7年5月末",
            "book_title_ko" : "조선제학교일람 1932년도",
            "numeration" : "1932",
            "authors" : null,
            "authors_ko" : null,
            "publish_info" : null,
            "publish_year" : null,
            "publish_month" : null,
            "publish_day" : null,
            "publish_date" : null,
            "publisher" : "朝鮮總督府>學務局",
            "publisher_ko" : "조선총독부>학무국",
            "library" : null,
            "url" : null,
            "note" : null,
            "search_tag" : null,
            "usernote" : null
        },
        {
            "book_id" : 54,
            "book_type" : null,
            "book_category" : "joseon_school_catalog",
            "book_title" : "朝鮮諸學校一覽 昭和8年5月末",
            "book_title_ko" : "조선제학교일람 1933년도",
            "numeration" : "1933",
            "authors" : null,
            "authors_ko" : null,
            "publish_info" : null,
            "publish_year" : 1934,
            "publish_month" : 5,
            "publish_day" : 30,
            "publish_date" : "소화9년5월30일",
            "publisher" : "朝鮮總督府>學務局",
            "publisher_ko" : "조선총독부>학무국",
            "library" : null,
            "url" : null,
            "note" : null,
            "search_tag" : null,
            "usernote" : null
        },
        {
            "book_id" : 55,
            "book_type" : null,
            "book_category" : "joseon_school_catalog",
            "book_title" : "朝鮮諸學校一覽 昭和9年5月末",
            "book_title_ko" : "조선제학교일람 1934년도",
            "numeration" : "1934",
            "authors" : null,
            "authors_ko" : null,
            "publish_info" : null,
            "publish_year" : 1935,
            "publish_month" : 4,
            "publish_day" : 10,
            "publish_date" : "소화10년4월10일",
            "publisher" : "朝鮮總督府>學務局",
            "publisher_ko" : "조선총독부>학무국",
            "library" : null,
            "url" : null,
            "note" : null,
            "search_tag" : null,
            "usernote" : null
        },
        {
            "book_id" : 56,
            "book_type" : null,
            "book_category" : "joseon_school_catalog",
            "book_title" : "朝鮮諸學校一覽 昭和10年5月末",
            "book_title_ko" : "조선제학교일람 1935년도",
            "numeration" : "1935",
            "authors" : null,
            "authors_ko" : null,
            "publish_info" : null,
            "publish_year" : 1936,
            "publish_month" : 4,
            "publish_day" : 10,
            "publish_date" : "소화11년4월10일",
            "publisher" : "朝鮮總督府>學務局",
            "publisher_ko" : "조선총독부>학무국",
            "library" : null,
            "url" : null,
            "note" : null,
            "search_tag" : null,
            "usernote" : null
        },
        {
            "book_id" : 57,
            "book_type" : null,
            "book_category" : "joseon_school_catalog",
            "book_title" : "朝鮮諸學校一覽 昭和11年5月末",
            "book_title_ko" : "조선제학교일람 1936년도",
            "numeration" : "1936",
            "authors" : null,
            "authors_ko" : null,
            "publish_info" : null,
            "publish_year" : 1937,
            "publish_month" : 2,
            "publish_day" : 20,
            "publish_date" : "소화12년2월20일",
            "publisher" : "朝鮮總督府>學務局",
            "publisher_ko" : "조선총독부>학무국",
            "library" : null,
            "url" : null,
            "note" : null,
            "search_tag" : null,
            "usernote" : null
        },
        {
            "book_id" : 58,
            "book_type" : null,
            "book_category" : "joseon_school_catalog",
            "book_title" : "朝鮮諸學校一覽 昭和12年5月末",
            "book_title_ko" : "조선제학교일람 1937년도",
            "numeration" : "1937",
            "authors" : null,
            "authors_ko" : null,
            "publish_info" : null,
            "publish_year" : 1938,
            "publish_month" : 3,
            "publish_day" : 5,
            "publish_date" : "소화13년3월5일",
            "publisher" : "朝鮮總督府>學務局",
            "publisher_ko" : "조선총독부>학무국",
            "library" : null,
            "url" : null,
            "note" : null,
            "search_tag" : null,
            "usernote" : null
        },
        {
            "book_id" : 59,
            "book_type" : null,
            "book_category" : "joseon_school_catalog",
            "book_title" : "朝鮮諸學校一覽 昭和13年5月末",
            "book_title_ko" : "조선제학교일람 1938년도",
            "numeration" : "1938",
            "authors" : null,
            "authors_ko" : null,
            "publish_info" : null,
            "publish_year" : 1939,
            "publish_month" : 3,
            "publish_day" : 5,
            "publish_date" : "소화14년3월5일",
            "publisher" : "朝鮮總督府>學務局",
            "publisher_ko" : "조선총독부>학무국",
            "library" : null,
            "url" : null,
            "note" : null,
            "search_tag" : null,
            "usernote" : null
        },
        {
            "book_id" : 60,
            "book_type" : null,
            "book_category" : "joseon_school_catalog",
            "book_title" : "朝鮮諸學校一覽 昭和14年5月末",
            "book_title_ko" : "조선제학교일람 1939년도",
            "numeration" : "1939",
            "authors" : null,
            "authors_ko" : null,
            "publish_info" : null,
            "publish_year" : 1940,
            "publish_month" : 3,
            "publish_day" : 5,
            "publish_date" : "소화15년3월5일",
            "publisher" : "朝鮮總督府>學務局",
            "publisher_ko" : "조선총독부>학무국",
            "library" : null,
            "url" : null,
            "note" : null,
            "search_tag" : null,
            "usernote" : null
        },
        {
            "book_id" : 61,
            "book_type" : null,
            "book_category" : "joseon_school_catalog",
            "book_title" : "朝鮮諸學校一覽 昭和15年5月末",
            "book_title_ko" : "조선제학교일람 1940년도",
            "numeration" : "1940",
            "authors" : null,
            "authors_ko" : null,
            "publish_info" : null,
            "publish_year" : 1941,
            "publish_month" : 4,
            "publish_day" : 30,
            "publish_date" : "소화16년4월30일",
            "publisher" : "朝鮮總督府>學務局",
            "publisher_ko" : "조선총독부>학무국",
            "library" : null,
            "url" : null,
            "note" : null,
            "search_tag" : null,
            "usernote" : null
        },
        {
            "book_id" : 62,
            "book_type" : null,
            "book_category" : "joseon_school_catalog",
            "book_title" : "朝鮮諸學校一覽 昭和16年5月末",
            "book_title_ko" : "조선제학교일람 1941년도",
            "numeration" : "1941",
            "authors" : null,
            "authors_ko" : null,
            "publish_info" : null,
            "publish_year" : 1942,
            "publish_month" : 5,
            "publish_day" : 30,
            "publish_date" : "소화17년5월30일",
            "publisher" : "朝鮮總督府>學務局",
            "publisher_ko" : "조선총독부>학무국",
            "library" : null,
            "url" : null,
            "note" : null,
            "search_tag" : null,
            "usernote" : null
        },
        {
            "book_id" : 63,
            "book_type" : null,
            "book_category" : "joseon_school_catalog",
            "book_title" : "朝鮮諸學校一覽 昭和17年5月末",
            "book_title_ko" : "조선제학교일람 1942년도",
            "numeration" : "1942",
            "authors" : null,
            "authors_ko" : null,
            "publish_info" : null,
            "publish_year" : 1943,
            "publish_month" : 5,
            "publish_day" : 30,
            "publish_date" : "소화18년5월30일",
            "publisher" : "朝鮮總督府>學務局",
            "publisher_ko" : "조선총독부>학무국",
            "library" : null,
            "url" : null,
            "note" : null,
            "search_tag" : null,
            "usernote" : null
        },
        {
            "book_id" : 64,
            "book_type" : null,
            "book_category" : "joseon_school_catalog",
            "book_title" : "朝鮮諸學校一覽 昭和18年5月末",
            "book_title_ko" : "조선제학교일람 1943년도",
            "numeration" : "1943",
            "authors" : null,
            "authors_ko" : null,
            "publish_info" : null,
            "publish_year" : 1944,
            "publish_month" : 6,
            "publish_day" : 10,
            "publish_date" : "소화19년6월10일",
            "publisher" : "朝鮮總督府>學務局",
            "publisher_ko" : "조선총독부>학무국",
            "library" : null,
            "url" : null,
            "note" : null,
            "search_tag" : null,
            "usernote" : null
        }
    ]


